import $ from 'jquery';
// import 'select2';
/* global x5script */

class Select2 {
  constructor() {
    this.selectField = $('.js-select2');

    if (!this.selectField.length) {
      return;
    }

    this.provinceOptions = x5script.provinceOptions;
    this.provinceSelectOptions = [];

    for (let i = 0; i < this.provinceOptions.length; i += 1) {
      const provinceData = this.provinceOptions[i];
      this.provinceSelectOptions.push({
        id: provinceData.label,
        text: provinceData.label,
      });
    }

    import('select2').then(() => {
      this.createFields();
    });
  }

  createFields() {
    $.each(this.selectField, (i, el) => {
      const selectField = $(el);
      const dataType = selectField.data('data-type') || null;
      const allowSearch = selectField.data('allow-search') || 'no';
      const sortAZ = selectField.data('sort-az') || 'no';
      const showClear = selectField.data('allow-clear') || 'yes';

      const params = {
        placeholder: selectField.data('placeholder'),
        allowClear: showClear === 'yes',
        closeOnSelect: true,
      };

      if (allowSearch === 'no') {
        params.minimumResultsForSearch = -1;
      }

      if (dataType === 'province') {
        params.data = this.provinceSelectOptions;
      }

      if (sortAZ === 'yes') {
        params.sorter = data =>
          data.sort((a, b) => a.text.localeCompare(b.text));
      }

      selectField.select2(params);
    });
  }
}

export default new Select2();



// WEBPACK FOOTER //
// ./src/scripts/modules/select2.js